<template>
  <div class="home" :style="{backgroundImage: 'url(' + poetry.coverUrl + ')'}">
    <div class="logo">
      <img src="../assets/logo.png" alt="logo">
    </div>
    <div class="search">
      <input type="text" v-model="keyword" placeholder="" @keyup.enter="toSearch">
      <img src="../assets/search.webp" alt="search" @click="toSearch">
    </div>
    <div class="placeholder">

    </div>
    <div class="beian">
      <a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备20006294号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      keyword: '',
      poetry: {}
    }
  },
  methods: {
    get() {
      this.$get('/poetryapi/daypoetry/list', {pageNum: 1, pageSize: 15, all: false}).then(res => {
        this.poetry = res[Math.floor(Math.random() * res.length)];
      });
    },
    toSearch() {
      if (this.keyword) {
        this.$router.push('/search/' + this.keyword);
      }
    }
  },
  mounted() {
    document.title = '诗词馆';
    this.get();
  }
}
</script>

<style scoped lang="less">
.home {
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .placeholder {
    width: 100%;
    height: 256px;
  }
  .logo {
    margin-top: 24px;
    text-align: center;

    img {
      width: 60px;
      height: 60px;
    }
  }
  .search {
    width: 90%;
    margin: 12px 12px 0 12px;
    background: #FFFFFF;
    border-radius: 6px;
    height: 42px;
    display: flex;
    box-shadow: 0 1px 3px 1px rgba(0,0,0,.14);
    -webkit-box-shadow: 0 1px 3px 1px rgba(0,0,0,.14);

    input {
      flex: 1;
      background: rgba(00, 00, 00, 0);
      border: none;
      padding: 3px 12px;
    }
    input:focus{
      outline: none;
    }
    img {
      width: 30px;
      height: 30px;
      padding: 6px;
    }
  }

  .beian {
    text-align: center;
  }
}
</style>
